module.exports = __webpack_public_path__ + "static/media/forward.6c0abe21.svg";